import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=0d4d604c&lang=pug&"
import script from "./SidebarNav.vue?vue&type=script&lang=js&"
export * from "./SidebarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports